import React from "react";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import {
  Alert,
  Button,
  MenuItem,
  Modal,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useMemo, useState } from "react";
import { useBaseContext } from "../../context/BaseContext";
import { BeroepsI1a1April17 } from "../DataDisplay/BEROEPSMSE1/BeroepsI1a1April17";
import { BeroepsI1a1May17 } from "../DataDisplay/BEROEPSMSE1/BeroepsI1a1May17";
import { BeroepsI1b1April14 } from "../DataDisplay/BEROEPSMSE1/BeroepsI1b1April14";
import { BeroepsI1b2April15 } from "../DataDisplay/BEROEPSMSE1/BeroepsI1b2April15";
import { Interface1HtmlCss4 } from "../DataDisplay/INTERFACE1/Interface1HtmlCss4";
import { IttechCustomJoins } from "../DataDisplay/ITTECH2/IttechCustomJoins";
import { IttechPowershellRepeat } from "../DataDisplay/ITTECH2/IttechPowershellRepeat";
import { IttechCustomJoins2 } from "../DataDisplay/ITTECH2/IttechCustomJoins2";
import { IttechCustomJoins3 } from "../DataDisplay/ITTECH2/IttechCustomJoins3";
import { IttechFfmpegRecap } from "../DataDisplay/ITTECH2/IttechFfmpegRecap";
import { IttechDatabasesQueryRecap } from "../DataDisplay/ITTECH2/IttechDatabasesQueryRecap";
import { KdappontAiTraining } from "../DataDisplay/KDAPPONT2/KdappontAiTraining";
import { KdappontLesson1 } from "../DataDisplay/KDAPPONT2/KdappontLesson1";
import { KdappontLesson2 } from "../DataDisplay/KDAPPONT2/KdappontLesson2";
import { KdappontLesson3 } from "../DataDisplay/KDAPPONT2/KdappontLesson3";
import { KdappontLesson5 } from "../DataDisplay/KDAPPONT2/KdappontLesson5";
import { KdappontLesson6 } from "../DataDisplay/KDAPPONT2/KdappontLesson6";
import { KdappontLesson7 } from "../DataDisplay/KDAPPONT2/KdappontLesson7";
import { KdappontLesson8 } from "../DataDisplay/KDAPPONT2/KdappontLesson8";
import { KdappontCssLesson1 } from "../DataDisplay/KDAPPONT2/KdappontCssLesson1";
import { KdappontCssLesson2 } from "../DataDisplay/KDAPPONT2/KdappontCssLesson2";
import { KdappontCssLesson3 } from "../DataDisplay/KDAPPONT2/KdappontCssLesson3";
import { KdappontCssLesson4 } from "../DataDisplay/KDAPPONT2/KdappontCssLesson4";
import { KdappontCssLesson5 } from "../DataDisplay/KDAPPONT2/KdappontCssLesson5";
import { KdappontCssLesson6 } from "../DataDisplay/KDAPPONT2/KdappontCssLesson6";
import { KdappontExamTraining } from "../DataDisplay/KDAPPONT2/KdappontExamTraining";
import { KdappontExamTraining2 } from "../DataDisplay/KDAPPONT2/KdappontExamTraining2";
import { KdappontWebInspector } from "../DataDisplay/KDAPPONT2/KdappontWebInspector";
import { LEDWorkshop } from "../DataDisplay/LED/LEDWorkshop";
import { TableData } from "../DataDisplay/TableData";
import data from "./PresentationData2526.json";

type ComponentRegistry = Record<string, React.ComponentType<any>>;

const componentRegistry: ComponentRegistry = {
  "table-data": TableData,
  IttechCustomJoins,
  IttechCustomJoins2,
  IttechCustomJoins3,
  KdappontAiTraining,
  KdappontWebInspector,
  BeroepsI1b1April14,
  BeroepsI1b2April15,
  BeroepsI1a1April17,
  BeroepsI1a1May17,
  Interface1HtmlCss4,
  KdappontExamTraining,
  KdappontExamTraining2,
  IttechPowershellRepeat,
  KdappontLesson1,
  KdappontLesson2,
  KdappontLesson3,
  KdappontLesson5,
  KdappontLesson6,
  KdappontLesson7,
  KdappontLesson8,
  KdappontCssLesson1,
  KdappontCssLesson2,
  KdappontCssLesson3,
  KdappontCssLesson4,
  KdappontCssLesson5,
  KdappontCssLesson6,
  IttechFfmpegRecap,
  IttechDatabasesQueryRecap,
  LEDWorkshop,
};

const SUBJECTS = [
  // "ITTECH2",
  // "KDAPPONT2",
  // "KDMICRO1",
  "LED",
  // "INTERFACE1",
  // "LIVE1",
  // "BEROEPSMSE1",
] as const;
type PresentationCategories = (typeof SUBJECTS)[number];

type PresentationItem = {
  title?: string;
  disableTitle?: boolean;
  sub?: string;
  file?: string;
  type?: "image" | "embed" | "component";
  variant?: string;
  data?: any;
};

type PresentationData = Partial<{
  ITTECH2: PresentationItem[];
  KDAPPONT2: PresentationItem[];
  INTERFACE1: PresentationItem[];
  LIVE1: PresentationItem[];
  BEROEPSMSE1: PresentationItem[];
  KDMICRO1: PresentationItem[];
  LED: PresentationItem[];
}>;

export const PresentationModal = () => {
  const { isModalOpen, setIsModalOpen } = useBaseContext();

  const handleClose = () => setIsModalOpen(false);

  const [activeCategory, setActiveCategory] =
    useState<PresentationCategories>("LED");
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSubjectChange = (
    event: SelectChangeEvent<PresentationCategories>,
  ) => {
    setActiveCategory(event.target.value as PresentationCategories);
    setActiveIndex(0);
  };

  const items = useMemo(
    () => [...((data as PresentationData)[activeCategory] ?? [])].reverse(),
    [activeCategory],
  );

  const activeItem = items[activeIndex];

  const nextItem = () => {
    if (activeIndex < items.length - 1) {
      setActiveIndex((prevIndex) => prevIndex + 1);
    }
  };

  const prevItem = () => {
    if (activeIndex > 0) {
      setActiveIndex((prevIndex) => prevIndex - 1);
    }
  };

  return (
    <Modal
      disableAutoFocus
      open={isModalOpen}
      onClose={handleClose}
      sx={{
        backdropFilter: "blur(4px)",
      }}
    >
      <Box
        sx={{
          borderRadius: 3,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95vw",
          bgcolor: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(1px)",
          maxHeight: "96vh",
          overflow: "auto",
          p: 2,
          paddingBottom: 1,
        }}
      >
        <Stack
          gap={3}
          sx={{
            maxHeight: "calc(96vh - 104px)",
            paddingBottom: "20px",
            overflow: "auto",
          }}
        >
          {items.length > 0 ? (
            <>
              {activeItem.title && !activeItem.disableTitle && (
                <Typography
                  variant="h4"
                  component="h4"
                  mb={2}
                  py={1}
                  textAlign="center"
                  sx={{
                    // position: "sticky",
                    top: 0,
                    background: "rgb(0 255 163 / 0.7)",
                    backdropFilter: "blur(4px)",
                    borderRadius: 5,
                    boxShadow: "0px 5px 5px #37373710",
                    zIndex: 1,
                  }}
                >
                  {activeItem.title}
                </Typography>
              )}
              {activeItem.sub && (
                <Alert
                  severity="info"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="h5">{activeItem.sub}</Typography>
                </Alert>
              )}

              {activeItem.type === "embed" && (
                <embed
                  src={activeItem.file}
                  style={{ width: "100%", height: "90vh" }}
                />
              )}

              {activeItem.type === "image" && (
                <img src={activeItem.file} alt="presentation-image" />
              )}

              {activeItem.type === "component" &&
                (() => {
                  const key = activeItem.variant ?? "";
                  const Comp = componentRegistry[key];
                  if (!Comp) {
                    return (
                      <Alert severity="warning">
                        Onbekende component-variant: <code>{key}</code>
                      </Alert>
                    );
                  }
                  // We always pass `data` if present; components that don't need it can ignore it.
                  return (
                    <Comp
                      {...(activeItem.data ? { data: activeItem.data } : {})}
                    />
                  );
                })()}
            </>
          ) : (
            <Typography variant="h5" textAlign="center">
              Er zijn geen slides voor dit onderwerp.
            </Typography>
          )}
        </Stack>

        <Box
          justifyContent="center"
          display="flex"
          pt={1}
          borderTop={1}
          borderColor="divider"
        >
          <Stack direction="row" gap={1}>
            <Button
              size="small"
              onClick={nextItem}
              disabled={activeIndex >= items.length - 1 || items.length === 0}
              variant="outlined"
            >
              {activeIndex < items.length - 1 && items.length > 0
                ? `${items[activeIndex + 1].title}`
                : ""}
              <ArrowLeft />
            </Button>
            <Select
              sx={{
                height: "32px",
                fontSize: ".8em",
                overflow: "hidden",
              }}
              value={activeCategory}
              onChange={handleSubjectChange}
            >
              {SUBJECTS.map((subject) => {
                return (
                  <MenuItem key={subject} value={subject}>
                    {subject}
                  </MenuItem>
                );
              })}
            </Select>
            <Button
              size="small"
              onClick={prevItem}
              disabled={activeIndex <= 0 || items.length === 0}
              variant="outlined"
            >
              <ArrowRight />
              {activeIndex > 0 && items.length > 0
                ? `${items[activeIndex - 1].title}`
                : ""}
            </Button>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};
